import React, { FC, ReactNode } from 'react';
import { SpanRegistrar } from '@trp-ta-nitro/otel-browser-js';

export const registrarContext = React.createContext<SpanRegistrar | undefined>(undefined);

export interface Props {
  children?: ReactNode;
  registrar: SpanRegistrar;
}

const SpanRegistrarProvider: FC<Props> = (props) => {
  const { children, registrar } = props;

  return (
    <registrarContext.Provider value={registrar}>{children}</registrarContext.Provider>
  );
};

export default SpanRegistrarProvider;
